/**
 * Feature flag key constants — single source of truth for all flag keys used in the frontend.
 *
 * When introducing a new flag:
 *   1. Add its constant here (must match the key in service/featureflags/keys.go exactly).
 *   2. Use the constant at every CheckFeatureFlag call site — never write the key string inline.
 *
 * When retiring a flag:
 *   1. Remove all CheckFeatureFlag call sites that reference the constant.
 *   2. Delete the constant from this file.
 *   3. Set the flag status to "removed" in the Admin UI, then soft-delete it.
 */
export const FeatureFlags = {
  AlertTypesReactAdmin: "release__alert_types__react_admin",
  AlertsV2: "release__alerts__v2",
  APIRateLimiting: "ops__api__rate_limiting",
  CallingSharedLinks: "release__calling__shared_links",
  CarlieAppointmentScheduling: "release__carlie__appointment_scheduling",
  CarlieAssistDashboard: "release__carlie__assist_dashboard",
  CarlieOpcodeAllowlist: "release__carlie__opcode_allowlist",
  CarlieProductEntitlements: "release__carlie__product_entitlements",
  CarlieV1: "release__carlie__v1",
  DealTypesReactAdmin: "release__deal_types__react_admin",
  ExternalTelephonyRingCentral: "release__external_telephony__ring_central",
  IntegrationsHubMykaarma: "release__integrations_hub__mykaarma",
  IntegrationsHubXtime: "release__integrations_hub__xtime",
  MyKaarmaScreenPopping: "release__mykaarma__screen_popping",
  PulseAlertsSharedLink: "release__pulse_alerts__shared_link",
  PulseAlertsSlackAlerts: "release__pulse_alerts__slack_alerts",
  PulseAlertsTeamsAlerts: "release__pulse_alerts__teams_alerts",
  PulseTwoPartyAgentLeg: "ops__pulse__two_party_agent_leg",
  SdeImportRowExplorer: "release__sde__import_row_explorer",
  SipOutboundTransfer: "release__sip__outbound_transfer",
  TekionCrmLeadIngestion: "release__tekion__crm_lead_ingestion",
  WorkplansAccountLevelEnabled: "release__workplans__account_level_enabled",
  WorkplansNavLink: "release__workplans__nav_link",
  WorkplansPulsePromises: "release__workplans__pulse_promises",
} as const;
